import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  containerResponse: {
    marginVertical: 16,
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    paddingVertical: 8,
  },
  cornerResponse: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    borderRadius: 16,
    borderColor: 'rgba(240, 244, 248, 0.875)',
    borderWidth: 1,
    maxWidth: 395,
    backgroundColor: 'rgba(240, 244, 248, 0.875)',
  },
  cornerInResponse: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 16,
    borderRadius: 16,
    borderColor: 'rgba(0, 0, 0, 1)',
    borderWidth: 1,
    maxWidth: 395,
    backgroundColor: 'rgba(255, 255, 255, 0.875)',
  },
  txtBlack: {
    color: 'rgba(29, 92, 66, 1)',
    fontSize: 32,
    fontWeight: '400',
  },
  txtGreen: {
    color: 'rgba(29, 92, 66, 1)',
    fontSize: 32,
    fontWeight: '700',
  },
});
